import React from 'react'
import Switch from 'react-switch'

const Switcher = ({ checked, onChange }) => {
  return <Switch onChange={onChange} checked={checked} onColor="#120cca" />
}

export default Switcher
